module.exports = __webpack_public_path__ + "static/img/ttr09.46ae8d7.png";